<template>
  <v-dialog
    v-model="dialog"
    width="300"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          small
          :color="task.active ? 'green' : 'red'"
        >
          fas fa-circle
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Please confirm status!</v-card-title>
      <v-card-text>
        Sure want to turn {{ task.name }} schedule <span :class="task.active ? 'green--text' : 'red--text'">{{ task.active ? 'OFF' : 'ON' }}</span> ?
      </v-card-text>
      <v-alert
        v-if="errorMsg !== ''"
        type="error"
      >
        {{ errorMsg === null ? 'Execut Fail!' : errorMsg }}
      </v-alert>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          text
          :loading="loading"
          color="warning"
          @click="exec"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { scheduler } from '@rhitics/core'

export default {
  name: 'TaskActiveDialog',

  props: {
    task: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      errorMsg: ''
    }
  },

  mounted() {
    this.errorMsg = ''
  },
  methods: {
    async exec() {
      try {
        this.loading = true
        const { id, active } = this.task
        const postPayload = { id, active: !active }
        await scheduler.task.update(postPayload)
        this.$emit('update')
        this.dialog = false
      } catch (error) {
        console.info(error)
        this.errorMsg = error.message
      }
      this.loading = false
    }
  }
}
</script>
